export const PRIVACY_POLICY_URL = 'https://www.knowmebest.com/privacy-policy'
export const TERMS_AND_SERVICE_URL = 'https://www.knowmebest.com/terms-of-service'
